import type { Step } from "react-joyride";

export const auditPlanFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຟອມສ້າງ/ແກ້ໄຂຜະແນການກວດສອບ! ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີຕື່ມຂໍ້ມູນຜະແນການກວດສອບໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="plan-form-name"]',
    content: "ຕື່ມຊື່ຜະແນການກວດສອບ. ນີ້ແມ່ນຊື່ທີ່ຈະໃຊ້ເພື່ອກຳນົດຜະແນການກວດສອບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="plan-form-audit-type"]',
    content:
      "ເລືອກປະເພດການກວດສອບ. ທ່ານສາມາດເລືອກຈາກລາຍການທີ່ມີຢູ່ ຫຼືສ້າງໃໝ່ໂດຍກົດປຸ່ມການຕັ້ງຄ່າ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="plan-form-department"]',
    content: "ເລືອກພະແນກທີ່ຈະຖືກກວດສອບ. ນີ້ຈະກຳນົດວ່າພະແນກໃດຈະຖືກກວດສອບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="plan-form-auditor-position"]',
    content: "ເລືອກຕໍາແໜ່ງຜູ້ກວດສອບ. ນີ້ຈະກຳນົດວ່າຕໍາແໜ່ງໃດຈະມີສິດກວດສອບຕາມແຜນນີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="plan-form-frequency"]',
    content:
      "ເລືອກຄວາມຖີ່ການກວດສອບ. ທ່ານສາມາດເລືອກຈາກ: ປະຈຳເດືອນ, ປະຈຳໄຕມາດ, ຄັ້ງຕໍ່ 6 ເດືອນ, ປະຈຳປີ, ຫຼືຕາມຄວາມຈຳເປັນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="plan-form-next-date"]',
    content: "ເລືອກວັນທີກວດສອບຄັ້ງຖັດ. ນີ້ຈະກຳນົດວັນທີທີ່ຄວນຈະດຳເນີນການກວດສອບຄັ້ງຖັດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="plan-form-submit"]',
    content: "ຫຼັງຈາກຕື່ມຂໍ້ມູນທັງໝົດແລ້ວ, ກົດປຸ່ມ 'ບັນທຶກ' ເພື່ອບັນທຶກຜະແນການກວດສອບ.",
    placement: "top",
  },
];
